import React, { useEffect, useState, useRef } from 'react'
import API from '../../services/api';
import NoDataFound from '../../shared/NoDataFound';
import { SlIcon, SlTooltip } from '@shoelace-style/shoelace/dist/react'
import TableLoader from '../../shared/TableLoader'
import ScrollContainer from 'react-indiana-drag-scroll';
import config from '../../config';
import Paginator from "../../shared/Paginator";
import { debounce } from '../../utils/Debounce';
import {  useNavigate } from 'react-router';
import { roles } from '../../utils/constants';
import { CSVLink } from "react-csv";
import {formatDateDDMMYYY} from '../../utils/dateFormat'



function CustomerwiseSales() {
    const navigate = useNavigate()
    const [customerwiseSales, setCustomerwiseSales] = React.useState([])
    const [loader, setLoader] = useState(false)
    const [totalPages, setTotalPages] = useState(0)
    const [search, setSearch] = useState('')
    const [currentPage, setCurrentPage] = useState(0)
    const [downloadData, setDownloadData] = useState([])
    const [downloadLoader, setDownloadLoader] = useState(false)

    const fetchCustomerwiseSales = async() => {
        setLoader(true)
        try {
            let res = await API({
                url:'/finance_panel/customerwise-sales',
                method:'POST',
                responseType:'json',
                data:{
                    search:search,
                    limit: config.PER_PAGE,
                    offset:currentPage
                }
            })
            if(res.code === 200){
                setCustomerwiseSales(res.data?.data)
                setTotalPages(Math.ceil(res.data?.totalCounts / config.PER_PAGE));
            }
        } catch (error) {
            console.error(error);
        }
        finally{
            setLoader(false)
        }
    }

    const csvLinkRef = useRef(); // Create a ref for CSVLink
    let csvHeaders = [
      { label: "Invoice no", key: "invoice_no" },
      { label: "Order Id", key: "order_id" },
      { label: "Customer Name", key: "company_name" },
      { label: "Invoice Date", key: "invoice_date" },
      { label: "Total Amount", key: "invoice_amount" },
      { label: "Payment", key: "total_payment" },
      { label: "Due", key: "due_amount" },
  ];

    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
      };
      const downloadReport = async (
      ) => {
          setDownloadLoader(true);
          try {
        let result = await API({
            url: "/finance_panel/customerwise-report-download",
            method: "POST",
            responseType: "json",
            data: {
              search:search
            },
        });
        if (result?.code === 200) {
            setDownloadLoader(false);
            setDownloadData(result.data);
        }
          } catch (error) {
        setDownloadLoader(false);
        console.error(error);
        if (error.response.status === 401) navigate("/");
          }
      };
      useEffect(() => {
        if (downloadData.length) {
            csvLinkRef?.current?.link?.click();
            setDownloadData([]);
        }
      }, [downloadData]);

    useEffect(() => {
        fetchCustomerwiseSales()
    }, [search, currentPage])
  return (
    <>
        <h5>Customer wise Sales</h5>
        <div className='d-flex  gap-3 flex-wrap justify-end ml-auto mb-2 items-center'>
        <input type="text" className='form-control max-w-[280px]' placeholder='Customer / invoice / Sales' onChange={
            debounce((e) => setSearch(e.target.value), 500)}/>
        {( localStorage.getItem('role') === roles.financer) &&<div >
          <CSVLink
              data={downloadData.map(
                  ({
                    invoice_no,
                    order_id,
                    invoice_date,
                    company_name,
                    total_payment,
                    invoice_amount,
                    due_amount,
                  }) => {
                    let obj = {
                      order_id,
                      invoice_no,
                      total_payment,
                      company_name,
                      due_amount,
                      invoice_amount,
                      invoice_date: formatDateDDMMYYY(invoice_date)
                    };
  
                    return obj;
                  }              )}
              headers={csvHeaders}
              filename={"customer_wise_report.csv"}
              ref={csvLinkRef} // Assign the ref to the CSVLink component
          ></CSVLink>

          {downloadLoader ? (
              <TableLoader />
          ) : (
              <SlTooltip content="Export">
                  <SlIcon
                      library="lucide"
                      name="download"
                      className="w-6 h-6 cursor-default hover:text-sky-300 mr-1"
                      onClick={() => {
                          downloadReport(search)
                      }}
                  ></SlIcon>
              </SlTooltip>
          )}
        </div>}
        </div>
        <ScrollContainer>
        <table className='table table-bordered'> 
        <thead>
            <tr>
                <th>Customer Name</th>
                <th>Sales Person</th>
                <th>Invoice Id</th>
                <th>Payment</th>
                <th>Due</th>
            </tr>
            </thead>
            {(!loader && customerwiseSales.length > 0) ? <tbody > {customerwiseSales.map((item, index) => {
                return (
                    
                        <tr key={index}>
                            <td>{item.company_name}</td>
                            <td>{item.name}</td>
                            <td>{item.invoice_no}</td>
                            <td>{item.total_payment}</td>
                            <td>{item.due_amount}</td>
                        </tr>
                   
                )
            }) } </tbody>: loader ? <TableLoader colspan={4}/> : <NoDataFound  colspan={4}/>}
        </table>
        </ScrollContainer>
        <div className="flex justify-end">
        {totalPages > 1 && (
          <Paginator
            pageCount={totalPages}
            handlePageClick={handlePageClick}
            forcePage={currentPage}
          />
        )}
      </div>
    </>
  )
}

export default CustomerwiseSales